import { render, staticRenderFns } from "./GameRecordMySearchBarComponent.vue?vue&type=template&id=21734c7c&scoped=true"
import script from "./GameRecordMySearchBarComponent.vue?vue&type=script&lang=js"
export * from "./GameRecordMySearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./GameRecordMySearchBarComponent.vue?vue&type=style&index=0&id=21734c7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21734c7c",
  null
  
)

export default component.exports